export default "__VITE_PUBLIC_ASSET__90fdc0ca__"